import { Provider } from '@angular/core';

import { CdmDeviceUiApiService } from '../api';

import { SysApiCdmDeviceUiApiService } from './sys-api-cdm-device-ui-api.service';

export function provideCdmDeviceUiApiService(): Provider[] {
	return [
		SysApiCdmDeviceUiApiService,
		{
			provide: CdmDeviceUiApiService,
			useClass: SysApiCdmDeviceUiApiService
		}
	];
}
